import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6d1712c2")

_pushScopeId("data-v-6d1712c2")
const _hoisted_1 = { class: "m-form-skeleton" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  class: "skeleton-wrap",
  style: {"padding-bottom":"14px"}
}
const _hoisted_4 = {
  class: "skeleton-wrap",
  style: {"padding-bottom":"14px"}
}
const _hoisted_5 = {
  key: 1,
  class: "goods-skeleton",
  style: { display: 'flex' }
}
const _hoisted_6 = { class: "goods-skeleton-detail" }
const _hoisted_7 = {
  key: 2,
  class: "text-skeleton"
}
const _hoisted_8 = {
  key: 3,
  class: "mini-text-skeleton"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item")
  const _component_el_skeleton = _resolveComponent("el-skeleton")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_el_skeleton, {
      animated: "",
      count: $props.count,
      loading: $props.loading
    }, {
      template: _withId(() => [
        ($props.type === 'form')
          ? (_openBlock(), _createBlock("div", _hoisted_2, [
              _createVNode("div", _hoisted_3, [
                _createVNode(_component_el_skeleton_item, {
                  variant: "h3",
                  style: {"width":"100px","margin":"10px 0"}
                }),
                _createVNode(_component_el_skeleton_item, {
                  variant: "button",
                  style: {"width":"500px","display":"block"}
                })
              ]),
              _createVNode("div", _hoisted_4, [
                _createVNode(_component_el_skeleton_item, {
                  variant: "h3",
                  style: {"width":"100px","margin":"10px 0"}
                }),
                _createVNode(_component_el_skeleton_item, {
                  variant: "text",
                  style: {"width":"300px","display":"block","margin-bottom":"10px"}
                }),
                _createVNode(_component_el_skeleton_item, {
                  variant: "text",
                  style: {"width":"500px","display":"block"}
                })
              ])
            ]))
          : ($props.type === 'goods')
            ? (_openBlock(), _createBlock("div", _hoisted_5, [
                _createVNode(_component_el_skeleton_item, {
                  variant: "image",
                  style: {"width":"70px","height":"70px","border-radius":"4px"}
                }),
                _createVNode("div", _hoisted_6, [
                  _createVNode(_component_el_skeleton_item, {
                    variant: "p",
                    style: {"width":"160px"}
                  }),
                  _createVNode(_component_el_skeleton_item, {
                    variant: "text",
                    style: {"width":"220px"}
                  }),
                  _createVNode(_component_el_skeleton_item, {
                    variant: "text",
                    style: {"width":"260px"}
                  })
                ])
              ]))
            : ($props.type === 'text')
              ? (_openBlock(), _createBlock("div", _hoisted_7, [
                  _createVNode(_component_el_skeleton_item, {
                    variant: "text",
                    style: {"width":"600px"}
                  }),
                  _createVNode(_component_el_skeleton_item, {
                    variant: "text",
                    style: {"width":"600px"}
                  }),
                  _createVNode(_component_el_skeleton_item, {
                    variant: "text",
                    style: {"width":"400px"}
                  }),
                  _createVNode(_component_el_skeleton_item, {
                    variant: "text",
                    style: {"width":"300px"}
                  }),
                  _createVNode(_component_el_skeleton_item, {
                    variant: "text",
                    style: {"width":"250px"}
                  })
                ]))
              : ($props.type === 'mini-text')
                ? (_openBlock(), _createBlock("div", _hoisted_8, [
                    _createVNode(_component_el_skeleton_item, {
                      variant: "text",
                      style: {"width":"150px"}
                    }),
                    _createVNode(_component_el_skeleton_item, {
                      variant: "text",
                      style: {"width":"150px"}
                    }),
                    _createVNode(_component_el_skeleton_item, {
                      variant: "text",
                      style: {"width":"80px"}
                    })
                  ]))
                : _createCommentVNode("", true)
      ]),
      default: _withId(() => [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ]),
      _: 1
    }, 8, ["count", "loading"])
  ]))
})